module.exports = __webpack_public_path__ + "img/elc_benefit_card.ea1e36bb.svg";